var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationalLeftArrow = function SvgNavigationalLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.414 15 .943-.943-5.573-5.572h14.883V7.15H2.784l5.573-5.573-.943-.943L.231 7.818 7.414 15Z",
    fill: "#FFC83E"
  })));
};
export { SvgNavigationalLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxOCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQxNDA4IDE1TDguMzU2NzUgMTQuMDU3M0wyLjc4NDA4IDguNDg0NjdMMTcuNjY2NyA4LjQ4NDY3TDE3LjY2NjcgNy4xNTA2N0wyLjc4NDA4IDcuMTUwNjZMOC4zNTY3NSAxLjU3OEw3LjQxNDA4IDAuNjM1MzMxTDAuMjMxNDE1IDcuODE4TDcuNDE0MDggMTVaIiBmaWxsPSIjRkZDODNFIi8+Cjwvc3ZnPgo=";